/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMessageRequest } from '../../models/create-message-request';
import { MessageDetailResponse } from '../../models/message-detail-response';

export interface CreateMessage$Params {
      body: CreateMessageRequest
}

export function createMessage(http: HttpClient, rootUrl: string, params: CreateMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<MessageDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, createMessage.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MessageDetailResponse>;
    })
  );
}

createMessage.PATH = '/api/chat/message';
